var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dark-theme-switch",on:{"click":_vm.toggle}},[(_vm.dark)?_c('unicon',{attrs:{"name":"moon"}}):_c('unicon',{attrs:{"name":"sun"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }